import * as Sentry from '@sentry/react'

const API_BASE = '/api'

export async function fetchApi<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    ...options,
  })
  if (res.status === 401) {
    window.location.href = '/login'
    throw new Error('Not authenticated')
  }
  if (!res.ok) {
    const error = new Error(`API error: ${res.status} ${res.statusText}`)
    // 502はデプロイ時の一時的な瞬断のため、Sentryに報告しない
    if (res.status !== 502) {
      Sentry.captureException(error, {
        extra: { path, status: res.status },
      })
    }
    throw error
  }
  return res.json()
}
